import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import type { OverviewEntity, OverviewPartialState, OverviewState } from './overviews.reducer';
import { OVERVIEWS_FEATURE_KEY, overviewsAdapter } from './overviews.reducer';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { differenceInSeconds } from 'date-fns';
import type { Dictionary } from '@ngrx/entity';

const { selectEntities } = overviewsAdapter.getSelectors();

export const selectOverviewState = createFeatureSelector<OverviewState>(OVERVIEWS_FEATURE_KEY);

const selectOverviewEntities = createSelector(selectOverviewState, (state: OverviewState) => selectEntities(state));

export const selectCurrentOverviewId = createSelector(
  selectOverviewState,
  (state: OverviewState): string => state.currentOverviewId
);

export const selectCurrentOverview = createSelector(
  selectOverviewEntities,
  selectCurrentOverviewId,
  (entities: Dictionary<OverviewEntity>, id: string): OverviewEntity => entities[id]
);

export const getCurrentSelectedOverview = pipe(
  select(selectCurrentOverview),
  filter((x: OverviewEntity): boolean => !!x && x.status === 'Loaded'),
  distinctUntilChanged((a: OverviewEntity, b: OverviewEntity): boolean => {
    if (a.storeId !== b.storeId) {
      return false;
    }

    const diff = differenceInSeconds(new Date(b.fetchDate), new Date(a.fetchDate));
    console.log('Double event date diff filter: ', diff);

    return diff < 60;
  })
);

export const getOverviewByStoreId = createSelector<
  OverviewPartialState,
  { id: string },
  Record<string, OverviewEntity>,
  OverviewEntity
>(
  selectOverviewEntities,
  (articleEntities: Record<string, OverviewEntity>, props: { id: string }): OverviewEntity => articleEntities[props.id]
);
